const purchaseTypes: Record<string, string> = {
  signupAccepted: 'signup',
  upgradeAccepted: 'upgrade',
}

const containerTimeoutMs = 2000

declare global {
  interface Window {
    MatomoTagManager?: unknown
  }
}

/**
 * Events pushed before the async MTM container script has loaded only sit in `window._mtm`,
 * so they are lost if the page redirects first. Capped so a blocked tracker cannot stall checkout.
 */
function matomoContainerLoaded() {
  return new Promise<void>(resolve => {
    const deadline = Date.now() + containerTimeoutMs
    const check = () => {
      if (window.MatomoTagManager || Date.now() > deadline) {
        resolve()
      } else {
        setTimeout(check, 50)
      }
    }
    check()
  })
}

/**
 * Pushes `purchase_confirmed` to Matomo Tag Manager when the payment API reports success.
 * Ad pixels in MTM still rely on the thank-you page URL triggers until they are moved to this event.
 * Await before redirecting away from the page.
 */
export async function trackPurchaseConfirmed(successUrl: string) {
  const url = new URL(successUrl, location.origin)
  const [, , page = '', productCode, interval] = url.pathname.split('/')
  const purchaseType = purchaseTypes[page]
  if (!purchaseType || !window._mtm) {
    return
  }

  window._mtm.push({
    event: 'purchase_confirmed',
    purchase_type: purchaseType,
    product_code: productCode,
    subscription_interval: interval,
    ...Object.fromEntries(url.searchParams),
  })
  await matomoContainerLoaded()
}
